import React from 'react';
import ReactDOM from 'react-dom';
import { createHashHistory } from 'history';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { Provider } from 'react-redux';
import { ConnectedRouter, routerMiddleware } from 'connected-react-router/immutable';
import App from './App';
import rootReducer from './reducers';
import * as serviceWorker from './serviceWorker';
import './index.css';

const history = createHashHistory();

const store = createStore(
    rootReducer( history ),
    compose(
        applyMiddleware(
            routerMiddleware( history ),
            thunk
        )
    )
);

ReactDOM.render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <App />
        </ConnectedRouter>
    </Provider>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
